export {};

declare global {
  interface String {
    asQuery(): string;
    asIndex(): string;
    atIndex(index: number | string): string;
  }
}

String.prototype.asQuery = function (this: string): string {
  if (this.includes('#{$index}')) {
    return this.replace(/#\{\$index}/, '#*');
  }
  if (this.includes('#')) {
    return this.replace(/#[^#]*$/, '#*');
  }
  return this + '#*';
};

String.prototype.asIndex = function (this: string): string {
  if (this.includes('#{$index}')) {
    return this.toString();
  }
  return this + '#{$index}';
};

String.prototype.atIndex = function (this: string, index: number | string): string {
  if (this.includes('#{$index}')) {
    return this.replace(/#\{\$index}/, `#${index}`);
  }
  return this + `#${index}`;
};
